// extracted by mini-css-extract-plugin
export default {"Homepage":"Homepage_Homepage__vHA9n","CardDeckContainer":"Homepage_CardDeckContainer__Afp7N"};